import { useState } from "react";
import MyText from "./MyText";

export default function Checkbox({ title, obb, options, onChange }) {
    const [selected, setSelected] = useState(null);
    const handleSelect = (item) => {
        setSelected(item);
        if (onChange) {
            onChange(item);
        }
    };

    return (
        <div style={styles.container}>
            <MyText style={styles.title}>
                {title}{obb && <span style={{ color: 'red', fontSize: "0.6rem", verticalAlign: "super" }}>*</span>}
            </MyText>
            {options.map((item, index) => (
                <div style={styles.optionContainer}>
                    <label key={index} style={styles.option}>
                        <input
                            type="radio"
                            checked={selected === item}
                            onChange={() => handleSelect(item)}
                            style={styles.input}
                        />
                        {item}
                    </label>
                </div>
            ))}
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "left",
    },
    title: {
        fontSize: '1rem',
        fontFamily: 'Como-Bold',
        marginBottom: '0.5rem',
        color: "#282d68"
    },
    optionContainer: {
        marginBottom: "0.5rem"
    },
    input: {
        marginLeft: 0,
        marginRight: "0.5rem",
        color: "red",
        backgroundColor: "green"
    }
}